<template>
  <div v-if="loading" class="flex-1 uppercase">
    <div class="loading-placeholder"></div>
  </div>
  <div v-else 
    :class="`flex-1 uppercase cursor-pointer ${direction !== 'None' ? 'active': ''}`"
    @click="handleSort"
  >
    {{ label }}
    <i v-if="direction === 'None'" class="ico short-arrow-up" />
    <i v-else-if="direction === 'Asc'" class="ico short-arrow-up" />
    <i v-else-if="direction === 'Desc'" class="ico short-arrow-down" />
  </div>
</template>

<script>
// Utiliser les mêmes constantes que dans l'ancienne application React
const SORT_ASC = 'Asc'
const SORT_DESC = 'Desc'
const SORT_NONE = 'None'

export default {
  name: 'ListColumn',
  props: {
    loading: {
      type: Boolean,
      default: false
    },
    direction: {
      type: String,
      default: SORT_NONE
    },
    onSort: {
      type: Function,
      default: () => () => null
    },
    label: {
      type: String,
      default: ''
    },
    sortId: {
      type: String,
      default: ''
    }
  },
  methods: {
    handleSort() {
      let newDirection = SORT_ASC
      if (this.direction === SORT_ASC) {
        newDirection = SORT_DESC
      } else if (this.direction === SORT_DESC) {
        newDirection = SORT_NONE
      }
      this.onSort(newDirection)(this.sortId)
    }
  }
}
</script>
